import React, { useEffect } from 'react';
import { useAuth } from 'auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { RouteEnum } from 'modules/account/constantes/RouteEnum';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { USER, USER_DATA_KEY } from '../../constantes/LocalStorageEnum';
import { useGAEvents } from '../../../../hooks/useGoogleAnalytics';

// todo: chamar hook de limpar dados
// todo: padronizar hooks

export const resetStorage = () => {
  ApiLocalStorage.remove(USER_DATA_KEY);
  ApiLocalStorage.remove(USER);
  ApiLocalStorage.remove('@pwa-username');
  ApiLocalStorage.remove('@pwa-participantId');
  ApiLocalStorage.remove('@pwa-participant-id');
  ApiLocalStorage.remove('@pwa:access-token');
  ApiLocalStorage.remove('@pwa:otp-data');
  ApiLocalStorage.remove('@pwa:search-user-data');
  ApiLocalStorage.remove('currentBrand');
  ApiLocalStorage.remove('currentFaixa');
  ApiLocalStorage.remove('session-expiration');
  
  ApiLocalStorage.remove('segmentations_cache');
  ApiLocalStorage.remove('segmentations_timestamp');
  ApiLocalStorage.remove('performance_cache');
  ApiLocalStorage.remove('performance_timestamp');
  
}

const checkIfLoggedIn = async (logout: () => Promise<void>, navigate: (path: string) => void, location: string) => {
  const expirationTime = ApiLocalStorage.get('session-expiration');
  
  if ((!expirationTime) || new Date().getTime() > Number(expirationTime)) {
    
    const currentPath = location;
    
    const urlsLogin = Object.values(RouteEnum).filter(path => path !== RouteEnum.HOME);
    
    if ((currentPath as any) && !urlsLogin.includes(currentPath as any)) {
      resetStorage()
      await logout();
      navigate(RouteEnum.LOGIN_USERNAME);
    }
  }
};

export const startSessionWatcher = (logout: () => Promise<void>, navigate: (path: string) => void, location: string) => {
  checkIfLoggedIn(logout, navigate, location);
  
  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === 'session-expiration' && event.newValue === null) {
      checkIfLoggedIn(logout, navigate, location);
    }
  };
  
  const interval = setInterval(() => {
    checkIfLoggedIn(logout, navigate, location);
  }, 30000);
  
  window.addEventListener('storage', handleStorageChange);
  
  return () => {
    clearInterval(interval);
    window.removeEventListener('storage', handleStorageChange);
  };
};

const LogoutPage = () => {
  const {logout} = useAuth();
  const navigate = useNavigate();
  const { events } = useGAEvents();
  
  useEffect(() => {
    const handleLogout = async () => {
      // Evento GA4: Logout do usuário
      events.logout();
      
      await logout();
      await resetStorage();
      setTimeout(() => {
        navigate(RouteEnum.LOGIN_USERNAME);
      }, 200);
    }
    
    handleLogout();
  }, [events, logout, navigate]);
  
  return (
    <></>
  )
}

export default LogoutPage;
